/**
 * Migrada Fee Constants — Single Source of Truth
 * Last verified: April 3, 2026
 * Sources: OeAD (oead.at), oesterreich.gv.at, migration.gv.at, BMEIA (bmeia.gv.at)
 *
 * Every component that displays a fee MUST import from this file.
 * Never hardcode fee amounts in component JSX.
 *
 * Reference: /MIGRADA_2026_DATA_REFERENCE.md
 *
 * Values valid from January 1, 2026. Updated annually.
 */

export const FEES = {
  // Residence permit. From 1 January 2026 one flat fee covers application and
  // issuance of the card (Konsulargebührengesetz TP 1a, Gebührengesetz § 14
  // TP 8). The separate ~€89 card fee no longer applies. Verified 2026-10-02.
  APPLICATION: 218,
  RENEWAL: 218,

  // Visa D (Konsulargebührengesetz TP 7). Embassies may waive it for students
  // where the student's country does the same for Austrians. Verified 2026-10-02.
  VISA_D: 195,

  // Financial thresholds (2026, source: OeAD + oesterreich.gv.at)
  FINANCIAL_UNDER_24_MONTHLY: 722.58,
  FINANCIAL_UNDER_24_ANNUAL: 8671,
  FINANCIAL_24_PLUS_MONTHLY: 1308.39,
  FINANCIAL_24_PLUS_ANNUAL: 15701,
  RENT_THRESHOLD: 386.43,

  // Couple / child (2026)
  FINANCIAL_COUPLE_MONTHLY: 2064.12,
  FINANCIAL_CHILD_ADDITIONAL_MONTHLY: 201.88,

  // Insurance
  OGK_STUDENT_MONTHLY: 78.84,

  // Tuition. ÖH fee and total re-verified 2026-09-28 for winter semester
  // 2026/27 on studieren.univie.ac.at/studienbeitrag/hoehe-studienbeitrag
  // ("726,72 Euro" + "26,20 Euro" = "752,92 Euro pro Semester").
  NON_EU_TUITION_SEMESTER: 726.72,
  OEH_FEE_SEMESTER: 26.20,
  TOTAL_SEMESTER: 752.92,

  // Work
  MARGINAL_EARNINGS_MONTHLY: 551.10,

} as const;
